import { render, staticRenderFns } from "./IconHome.vue?vue&type=template&id=ade3ee96&scoped=true&"
import script from "./IconHome.vue?vue&type=script&lang=js&"
export * from "./IconHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../dates/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade3ee96",
  null
  
)

export default component.exports